import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { ChevronRight, MapPin, ArrowLeft, Pencil } from "lucide-react";
import { VEHICLE_IMAGES } from "../../../../Utils/Vehicleimg";
import useCustomerDetails from "../../../Services/Customer/useCustomerDetails";
import { GlobalContext } from "../../../../Context/GlobalContext";

const VehicleFareCard = ({
  onNext,
  onBack,
  selectedVehicle,
  setSelectedVehicle,
  formData,
  setFormData,
    setSelectedFare,
      setSelectedVehicleMeta,
}) => {
  const { car, truck, auto, bike } = VEHICLE_IMAGES;
 const { userCode, userID } = useContext(GlobalContext);
  const {
    computeDistanceRouteApi,
    computeDistanceRouteLoading,
    getFaresApi,
    getFaresLoading,
    bookParcelApi,
    getAllVehicleDetailsApi,
  } = useCustomerDetails();

 const [fareData, setFareData] = useState({
  twoWheelerFare: {},
  threeWheelerFare: {},
  fourWheelerFare: {},
  miniTruckFare: {},
});

  const [activeVehicle, setActiveVehicle] = useState("Two Wheeler");
  const [showPayment, setShowPayment] = useState(false);

const [payAt, setPayAt] = useState("Pick Up");
  const [paymentMode, setPaymentMode] = useState("UPI");

  const mapRef = useRef(null);
 const googleMapRef = useRef(null);
 const pickupMarkerRef = useRef(null);
const dropMarkerRef = useRef(null);
const routeLineRef = useRef(null);

const pickupLocation = useMemo(() => {
  return {
    lat: Number(formData?.pickupLatitude || 28.6139),
    lng: Number(formData?.pickupLongitude || 77.209),
  };
}, [formData]);

const [routeInfo, setRouteInfo] = useState({
  distance: "",
  duration: "",
  path: [],
});
const routePath = routeInfo.path || [];

 const normalizeComputedRoute = (apiResponse) => {
    const data =
      apiResponse?.response ||
      apiResponse?.data ||
      apiResponse?.result ||
      apiResponse ||
      {};

    const routeData = Array.isArray(data) ? data[0] : data;

    const encodedPolyline =
      routeData?.encodedPolyline ||
      routeData?.polyline ||
      routeData?.overview_polyline?.points ||
      routeData?.routes?.[0]?.polyline?.encodedPolyline ||
      routeData?.routes?.[0]?.overview_polyline?.points ||
      routeData?.routes?.[0]?.polyline ||
      "";

    const distanceText =
      routeData?.distanceText ||
      routeData?.distance ||
      routeData?.routes?.[0]?.distanceText ||
      routeData?.routes?.[0]?.legs?.[0]?.distance?.text ||
      "";

    const durationText =
      routeData?.durationText ||
      routeData?.duration ||
      routeData?.routes?.[0]?.durationText ||
      routeData?.routes?.[0]?.legs?.[0]?.duration?.text ||
      "";

    const routePoints =
      routeData?.route ||
      routeData?.path ||
      routeData?.points ||
      routeData?.coordinates ||
      routeData?.routes?.[0]?.path ||
      routeData?.routes?.[0]?.points ||
      [];

    let finalPath = [];

    if (
      encodedPolyline &&
      window.google?.maps?.geometry?.encoding?.decodePath
    ) {
      finalPath = window.google.maps.geometry.encoding
        .decodePath(encodedPolyline)
        .map((point) => ({
          lat: point.lat(),
          lng: point.lng(),
        }));
    } else if (Array.isArray(routePoints)) {
      finalPath = routePoints
        .map((point) => {
          const lat =
            point?.lat ||
            point?.latitude ||
            point?.location?.lat ||
            point?.location?.latitude;

          const lng =
            point?.lng ||
            point?.longitude ||
            point?.location?.lng ||
            point?.location?.longitude;

          return {
            lat: Number(lat),
            lng: Number(lng),
          };
        })
        .filter(Boolean);
    }

    return {
      path: finalPath,
      distanceText,
      durationText,
    };
  };

const dropLocation = useMemo(() => {
  return {
    lat: Number(formData?.dropLatitude || pickupLocation.lat + 0.018),
    lng: Number(formData?.dropLongitude || pickupLocation.lng + 0.018),
  };
}, [formData, pickupLocation]);

 const loadGoogleMap = () => {
    const googleKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    if (!googleKey) {
      console.error("Google Maps API key missing in .env");
      return;
    }

    if (window.google?.maps) {
      initMap();
      return;
    }

    const existingScript = document.getElementById("google-maps-script");

    if (existingScript) {
      existingScript.addEventListener("load", initMap);
      return;
    }

    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&libraries=geometry`;
    script.async = true;
    script.defer = true;
    script.onload = initMap;

    document.body.appendChild(script);
  };

  const initMap = () => {
    if (!mapRef.current || !window.google?.maps) return;

    if (!googleMapRef.current) {
      googleMapRef.current = new window.google.maps.Map(mapRef.current, {
        center: pickupLocation,
        zoom: 14,
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      });
    }

    renderMap();
  };

  const clearMapItems = () => {
    if (pickupMarkerRef.current) pickupMarkerRef.current.setMap(null);
    if (dropMarkerRef.current) dropMarkerRef.current.setMap(null);
    if (routeLineRef.current) routeLineRef.current.setMap(null);
  };

    const hideInfoWindowCloseButton = (infoWindow) => {
  infoWindow.addListener("domready", () => {
    const closeButtons = document.querySelectorAll(".gm-ui-hover-effect");

    closeButtons.forEach((btn) => {
      btn.style.display = "none";
    });
  });
};
  const renderMap = () => {
    if (!window.google?.maps || !googleMapRef.current) return;

    const map = googleMapRef.current;

    clearMapItems();

    pickupMarkerRef.current = new window.google.maps.Marker({
      map,
      position: pickupLocation,
      label: {
        text: "P",
        color: "#ffffff",
        fontWeight: "700",
      },
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 13,
        fillColor: "#2563eb",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 4,
      },
    });


    const pickupInfoWindow = new window.google.maps.InfoWindow({
  content: `
    <div style="
      max-width:220px;
      font-family:Arial,sans-serif;
      padding:0 10px 10px 10px;
      margin:0;
    ">
      <div style="
        font-size:15px;
        font-weight:700;
        margin:0 0 2px 0;
        line-height:18px;
        color:#111827;
      ">
        Pickup Address
      </div>

      <div style="
        font-size:12px;
        line-height:17px;
        color:#4b5563;
        word-break:break-word;
        margin:0;
        padding:0;
      ">
        ${
          formData?.pickupAddress ||
          formData?.pickup_location ||
          formData?.pickup ||
          "Pickup Location"
        }
      </div>
    </div>
  `,
});

pickupMarkerRef.current.addListener("mouseover", () => {
  pickupInfoWindow.open(map, pickupMarkerRef.current);
});

pickupMarkerRef.current.addListener("mouseout", () => {
  pickupInfoWindow.close();
});
hideInfoWindowCloseButton(pickupInfoWindow);


   dropMarkerRef.current = new window.google.maps.Marker({
  map,
  position: dropLocation,
  label: {
    text: "D",
    color: "#ffffff",
    fontWeight: "700",
  },
  icon: {
    path: window.google.maps.SymbolPath.CIRCLE,
    scale: 13,
    fillColor: "#16a34a",
    fillOpacity: 1,
    strokeColor: "#ffffff",
    strokeWeight: 4,
  },
});

const dropInfoWindow = new window.google.maps.InfoWindow({
  content: `
    <div style="
      max-width:220px;
      font-family:Arial,sans-serif;
      padding:0 10px 10px 10px;
      margin:0;
    ">
      <div style="
        font-size:15px;
        font-weight:700;
        margin:0 0 2px 0;
        line-height:18px;
        color:#111827;
      ">
        Drop Address
      </div>

      <div style="
        font-size:12px;
        line-height:17px;
        color:#4b5563;
        word-break:break-word;
        margin:0;
        padding:0;
      ">
        ${
          formData?.dropAddress ||
          formData?.drop_location ||
          formData?.drop ||
          "Drop Location"
        }
      </div>
    </div>
  `,
});
dropMarkerRef.current.addListener("mouseover", () => {
  dropInfoWindow.open(map, dropMarkerRef.current);
});

dropMarkerRef.current.addListener("mouseout", () => {
  dropInfoWindow.close();
});
hideInfoWindowCloseButton(dropInfoWindow);
const finalRoutePath =
  routePath && routePath.length > 1
    ? routePath
    : [pickupLocation, dropLocation];

    routeLineRef.current = new window.google.maps.Polyline({
      map,
      path: finalRoutePath,
      geodesic: true,
      strokeColor: "#2563eb",
      strokeOpacity: 0.95,
      strokeWeight: 5,
    });

    const bounds = new window.google.maps.LatLngBounds();

    bounds.extend(pickupLocation);
    bounds.extend(dropLocation);

   if (routePath?.length > 1) {
  routePath.forEach((point) => {
    bounds.extend(point);
  });
}

    map.fitBounds(bounds);

    setTimeout(() => {
      if (map.getZoom() > 15) {
        map.setZoom(15);
      }
    }, 300);
  };

useEffect(() => {
  loadGoogleMap();
}, []);

useEffect(() => {
  if (window.google?.maps && googleMapRef.current) {
    renderMap();
  }
}, [pickupLocation, dropLocation, routePath]);

  useEffect(() => {
   const fetchRouteAndFareDetails = async () => {
  const sessionUser = JSON.parse(
    sessionStorage.getItem("user") || "{}"
  );

  const customerId =
    userCode ||
    userID ||
    formData?.userCode ||
    formData?.userId ||
    formData?.userid ||
    sessionUser?.userCode ||
    sessionUser?.userid ||
    sessionUser?.userId ||
    "";

  const originLatitude =
    formData?.pickupLatitude ||
    formData?.originLatitude ||
    formData?.pickupLat ||
    formData?.fromLat ||
    formData?.pickupLocation?.lat ||
    formData?.pickupLocation?.latitude ||
    "";

  const originLongitude =
    formData?.pickupLongitude ||
    formData?.originLongitude ||
    formData?.pickupLng ||
    formData?.fromLng ||
    formData?.pickupLocation?.lng ||
    formData?.pickupLocation?.longitude ||
    "";

  const destinationLatitude =
    formData?.dropLatitude ||
    formData?.destinationLatitude ||
    formData?.dropLat ||
    formData?.toLat ||
    formData?.dropLocation?.lat ||
    formData?.dropLocation?.latitude ||
    "";

  const destinationLongitude =
    formData?.dropLongitude ||
    formData?.destinationLongitude ||
    formData?.dropLng ||
    formData?.toLng ||
    formData?.dropLocation?.lng ||
    formData?.dropLocation?.longitude ||
    "";

  if (!customerId) {
    return;
  }

  if (
    !originLatitude ||
    !originLongitude ||
    !destinationLatitude ||
    !destinationLongitude
  ) {
    return;
  }

  const routeRes = await computeDistanceRouteApi({
    originLatitude,
    originLongitude,
    destinationLatitude,
    destinationLongitude,
    customerId,
  });

  if (!routeRes || routeRes?.responseCode !== "00") {
    return;
  }

  const normalizedRoute = normalizeComputedRoute(routeRes);

  setRouteInfo({
    distance: normalizedRoute.distanceText || "",
    duration: normalizedRoute.durationText || "",
    path:
      normalizedRoute.path.length > 1
        ? normalizedRoute.path
        : [
            {
              lat: Number(originLatitude),
              lng: Number(originLongitude),
            },
            {
              lat: Number(destinationLatitude),
              lng: Number(destinationLongitude),
            },
          ],
  });

  const fareRes = await getFaresApi({
    customerId,
  });

  if (
    fareRes?.responseCode === "00" &&
    Array.isArray(fareRes?.data)
  ) {
    const fareMap = {
      1: "twoWheelerFare",
      2: "threeWheelerFare",
      3: "fourWheelerFare",
      4: "miniTruckFare",
    };

   const updatedFareData = {
  twoWheelerFare: {},
  threeWheelerFare: {},
  fourWheelerFare: {},
  miniTruckFare: {},
};

fareRes.data.forEach((item) => {
  const key = fareMap[item.vehicle_id];

  if (key) {
    updatedFareData[key] = {
      fare: Number(item.estimated_fare || 0),
      fareId: item.pk_fare_id,
      vehicleId: item.vehicle_id,
    };
  }
});

    setFareData(updatedFareData);
  }
};

    fetchRouteAndFareDetails();
  }, [
    formData?.customerId,
    formData?.userId,
    formData?.customer_id,
    formData?.senderMobile,

    formData?.pickupLatitude,
    formData?.originLatitude,
    formData?.pickupLat,
    formData?.fromLat,
    formData?.pickupLocation?.lat,
    formData?.pickupLocation?.latitude,

    formData?.pickupLongitude,
    formData?.originLongitude,
    formData?.pickupLng,
    formData?.fromLng,
    formData?.pickupLocation?.lng,
    formData?.pickupLocation?.longitude,

    formData?.dropLatitude,
    formData?.destinationLatitude,
    formData?.dropLat,
    formData?.toLat,
    formData?.dropLocation?.lat,
    formData?.dropLocation?.latitude,

    formData?.dropLongitude,
    formData?.destinationLongitude,
    formData?.dropLng,
    formData?.toLng,
    formData?.dropLocation?.lng,
    formData?.dropLocation?.longitude,
  ]);

  const faresLoading = computeDistanceRouteLoading || getFaresLoading;

  const vehicles = useMemo(
    () => [
     {
  name: "Two Wheeler",
  img: bike,
  price: fareData.twoWheelerFare?.fare || 0,
  fareId: fareData.twoWheelerFare?.fareId,
  vehicleId: fareData.twoWheelerFare?.vehicleId,
  toll: 0,
  detail: "",
  best: "Best for small parcels and quick delivery",
},
     {
  name: "Three Wheeler",
  img: auto,
  price: fareData.threeWheelerFare?.fare || 0,
  fareId: fareData.threeWheelerFare?.fareId,
  vehicleId: fareData.threeWheelerFare?.vehicleId,
  toll: 0,
   detail: "",
  best: "Best for medium goods and boxes",
},
{
  name: "Four Wheeler",
  img: car,
  price: fareData.fourWheelerFare?.fare || 0,
  fareId: fareData.fourWheelerFare?.fareId,
  vehicleId: fareData.fourWheelerFare?.vehicleId,
  toll: 0,
  detail: "",
  best: "Best for safe covered delivery",
},
{
  name: "Pickup Truck",
  img: truck,
  price: fareData.miniTruckFare?.fare || 0,
  fareId: fareData.miniTruckFare?.fareId,
  vehicleId: fareData.miniTruckFare?.vehicleId,
  toll: 0,
  detail: "",
  best: "Best for heavy and commercial goods",
},
    ],
    [
      bike,
      auto,
      car,
      truck,
      fareData.twoWheelerFare,
      fareData.threeWheelerFare,
      fareData.fourWheelerFare,
      fareData.miniTruckFare,
    ],
  );

  const normalizeVehicleName = (vehicle = "") => {
    const value = String(vehicle).trim().toLowerCase();

    if (
      value.includes("two") ||
      value.includes("2 wheeler") ||
      value === "2" ||
      value.includes("bike")
    ) {
      return "Two Wheeler";
    }

    if (
      value.includes("three") ||
      value.includes("3 wheeler") ||
      value === "3" ||
      value.includes("auto")
    ) {
      return "Three Wheeler";
    }

    if (
      value.includes("four") ||
      value.includes("4 wheeler") ||
      value === "4" ||
      value.includes("eeco") ||
      value.includes("car")
    ) {
      return "Four Wheeler";
    }

    if (
      value.includes("mini") ||
      value.includes("truck") ||
      value.includes("pickup")
    ) {
      return "Pickup Truck";
    }

    return "Two Wheeler";
  };
  
  const orderedVehicles = useMemo(() => {
    const selectedName = normalizeVehicleName(
      selectedVehicle || sessionStorage.getItem("selectedVehicle") || "",
    );

    const selected = vehicles.find((vehicle) => vehicle.name === selectedName);
    const others = vehicles.filter((vehicle) => vehicle.name !== selectedName);

    return selected ? [selected, ...others] : vehicles;
  }, [selectedVehicle, vehicles]);

  useEffect(() => {
    setActiveVehicle(orderedVehicles[0]?.name || "Two Wheeler");
  }, [orderedVehicles]);

  const selectedVehicleData =
    orderedVehicles.find((vehicle) => vehicle.name === activeVehicle) ||
    orderedVehicles[0];

  const fare = useMemo(() => {
    const tripFare = Number(selectedVehicleData?.price || 0);
    const tollCharges = Number(selectedVehicleData?.toll || 0);
    const netFare = tripFare + tollCharges;

    return {
      tripFare,
      tollCharges,
      netFare,
      amountPayable: netFare,
    };
  }, [selectedVehicleData]);

  function decodePolyline(str) {
  let index = 0,
    lat = 0,
    lng = 0,
    coordinates = [];

  while (index < str.length) {
    let b,
      shift = 0,
      result = 0;

    do {
      b = str.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    let dlat = result & 1 ? ~(result >> 1) : result >> 1;
    lat += dlat;

    shift = 0;
    result = 0;

    do {
      b = str.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    let dlng = result & 1 ? ~(result >> 1) : result >> 1;
    lng += dlng;

    coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }

  return coordinates;
}

useEffect(() => {
  setSelectedFare?.(fare.amountPayable);
}, [fare.amountPayable, setSelectedFare]);

const handleBookParcel = async () => {
  const sessionUser = JSON.parse(
    sessionStorage.getItem("user") || "{}"
  );

  const customerId =
    userCode ||
    userID ||
    formData?.userCode ||
    formData?.userId ||
    sessionUser?.userCode ||
    sessionUser?.userId ||
    "";

  const response = await bookParcelApi({
    vehilceId: selectedVehicleData?.vehicleId || "",
    fare: selectedVehicleData?.price || 0,
    fareId: selectedVehicleData?.fareId || "",

    pickUpTime:
  formData?.scheduleSlotTime ||
  formData?.scheduleSlotLabel ||
  formData?.scheduleTime ||
  "",

    customerId,

    senderName: formData?.senderName || "",
    senderNumber: formData?.senderMobile || "",

    receiverName: formData?.receiverName || "",
    receiverNumber: formData?.receiverMobile || "",
  });

  console.log("Book Parcel Response:", response);

if (response?.responseCode === "00") {

  const vehicleMeta = getVehicleMeta(
    selectedVehicleData?.vehicleId
  );

  setSelectedVehicleMeta({
    weight: vehicleMeta.weight,
    dimension: vehicleMeta.dimension,
  });

  onNext?.({
    parcelId:
      response?.data?.orderId ||
      response?.data?.parcelId ||
      response?.data?.bookingId ||
      "",
  });
}
};

const [vehicleDetails, setVehicleDetails] = useState([]);

useEffect(() => {
  const fetchVehicleDetails = async () => {
    const response = await getAllVehicleDetailsApi({
      userId: "",
    });

      console.log("Vehicle API Data", response?.data);

    if (response?.responseCode === "00") {
      setVehicleDetails(response?.data || []);
    }
  };

  fetchVehicleDetails();
}, []);

const getVehicleMeta = (vehicleId) => {
  const vehicle = vehicleDetails.find(
    (item) =>
      Number(item.pk_vehicle_id) === Number(vehicleId)
  );

  return {
    weight: vehicle?.weight || "-",
    dimension: vehicle?.dimensions || "-",
  };
};
  const handleVehicleSelect = (vehicleName) => {
    setActiveVehicle(vehicleName);

    sessionStorage.setItem("selectedVehicle", vehicleName);

    if (setSelectedVehicle) {
      setSelectedVehicle(vehicleName);
    }
  };

  return (
    <section className="w-full px-3 pb-6 pt-8 sm:px-4 md:px-6 md:pt-12 lg:px-0 lg:pt-0">
      <div className="mx-auto mt-10 grid w-full max-w-[1020px] overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_22px_70px_rgba(15,23,42,0.16)] sm:mt-4 md:mt-10 lg:mt-[120px] lg:grid-cols-[57%_43%]">
        {/* LEFT */}
        <div className="order-2 flex flex-col bg-white px-4 py-6 sm:px-6 sm:py-8 md:px-8 lg:order-1 lg:px-7 lg:py-5">
          <div className=" w-full max-w-[580px]">
            {/* BACK */}
            <button
              type="button"
              onClick={onBack}
              className="mb-4 inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              <ArrowLeft size={17} />
              Back to Address
            </button>

            {/* CONTACT INFO */}
            <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
              <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
                Contact Details
              </h3>

              <div className="grid grid-cols-1 gap-3 px-4 py-4 text-sm sm:grid-cols-2">
                <div>
                  <p className="text-gray-400">Sender</p>
                  <p className="font-semibold text-gray-800">
                    {formData?.senderName || "-"}
                  </p>
                  <p className="text-gray-500">
                    {formData?.senderMobile || "-"}
                  </p>
                </div>

                <div>
                  <p className="text-gray-400">Receiver</p>
                  <p className="font-semibold text-gray-800">
                    {formData?.receiverName || "-"}
                  </p>
                  <p className="text-gray-500">
                    {formData?.receiverMobile || "-"}
                  </p>
                </div>
              </div>
            </div>

            {/* FARE SUMMARY */}
            <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
              <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
                Fare Summary
              </h3>

              <div className="space-y-2 px-4 lg:pt-4 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">Selected Vehicle</span>
                  <span className="font-bold text-gray-800">
                    {selectedVehicleData.name}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Trip Fare</span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.tripFare.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">
                    Toll Charges
                    <span className="ml-1 rounded-full bg-orange-100 px-1.5 py-0.5 text-[9px] text-orange-500">
                      include
                    </span>
                  </span>

                  <span className="font-bold text-gray-800">
                    ₹ {fare.tollCharges.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Net Fare</span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.netFare.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between border-t py-2">
                  <span className="font-bold text-gray-500">
                    Amount Payable
                  </span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.amountPayable.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            {/* PAYMENT */}
<div className="mb-6 overflow-hidden rounded-lg border border-gray-200 bg-white">
  <div className="border-b px-4 py-3">
    <h3 className="text-[18px] font-semibold text-gray-800">
      Select Payment Mode
    </h3>
  </div>

  <button className="flex w-full items-center justify-between px-4 py-3 hover:bg-gray-50">
    <span className="font-medium text-gray-700">UPI</span>
    <span className="text-sm text-gray-400">
      Google Pay / PhonePe
    </span>
  </button>

  <button className="flex w-full items-center justify-between border-t px-4 py-3 hover:bg-gray-50">
    <span className="font-medium text-gray-700">
      Cash on Delivery
    </span>
    <span className="text-sm text-gray-400">
      Pay after delivery
    </span>
  </button>

  <button className="flex w-full items-center justify-between border-t px-4 py-3 hover:bg-gray-50">
    <span className="font-medium text-gray-700">
      Debit / Credit Card
    </span>
    <span className="text-sm text-gray-400">
      Visa, Mastercard
    </span>
  </button>
</div>
</div>
{/* Pay At Toggle */}
 <div className="flex items-center mb-6 justify-between rounded-lg border border-gray-200 bg-white px-4 py-3">
        
        <span className="text-[16px] font-semibold text-gray-800">
          Pay At
        </span>

        <div className="flex rounded-full bg-gray-100 p-1">
          
          <button
            onClick={() => setPayAt("Pick Up")}
            className={`rounded-full px-4 py-1 text-sm font-medium transition ${
              payAt === "Pick Up"
                ? "bg-white text-gray-800 shadow"
                : "text-gray-500 hover:text-gray-800"
            }`}
          >
            Pick Up
          </button>

          <button
            onClick={() => setPayAt("Drop")}
            className={`rounded-full px-4 py-1 text-sm font-medium transition ${
              payAt === "Drop"
                ? "bg-white text-gray-800 shadow"
                : "text-gray-500 hover:text-gray-800"
            }`}
          >
            Drop
          </button>

        </div>
      </div>
          {/* BOTTOM BUTTON */}
          <div
            className={`w-full max-w-[580px] transition-all duration-300 ${
              showPayment ? "mt-0" : "mt-2"
            }`}
          >
            <button
              type="button"
              onClick={handleBookParcel}
              className="w-full rounded-lg bg-[#1f2d3f] py-3 font-semibold text-white transition hover:opacity-90"
            >
              Driver is on the Way
            </button>
          </div>
        </div>

        {/* RIGHT */}
        <div className="order-1 lg:order-2 flex flex-col">
<div className="order-1 flex h-[420px] bg-slate-100 p-4 sm:h-[460px] md:h-[500px] lg:order-2 lg:h-full lg:p-5">
            <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
              <div ref={mapRef} className="h-full w-full" />
            </div>
          </div>

        <div className="order-1 bg-[#fbf6e7] px-4 py-6 sm:px-6 sm:py-8 lg:order-2 lg:px-7 lg:py-5">
          <div className="mx-auto max-w-[420px]">
            <h4 className="mb-3 text-base font-bold text-gray-500">
              Recommended Vehicles
            </h4>

            <div className="space-y-4">
              {orderedVehicles.map((vehicle) => (
                <div
                  key={vehicle.name}
                  onClick={() => handleVehicleSelect(vehicle.name)}
                  className={`cursor-pointer overflow-hidden rounded-lg border bg-white transition ${
                    activeVehicle === vehicle.name
                      ? "border-orange-400 bg-orange-100"
                      : "border-gray-200 hover:border-orange-200"
                  }`}
                >
                  <div
                    className={`flex items-center justify-between px-4 py-1 ${
                      activeVehicle === vehicle.name
                        ? "bg-orange-100"
                        : "bg-white"
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      <div className="flex h-16 w-16 items-center justify-center">
                        <img
                          src={vehicle.img}
                          alt={vehicle.name}
                          className="h-12 w-12 object-contain"
                        />
                      </div>

                      <div>
                        <h3 className="font-bold text-gray-800">
                          {vehicle.name}
                        </h3>

                        {activeVehicle === vehicle.name ? (
                          <div className="text-sm leading-5 text-gray-600">
                       <p>
  <b>Weight:</b>{" "}
  {getVehicleMeta(vehicle.vehicleId).weight}
</p>

<p>
  <b>Dimension:</b>{" "}
  {getVehicleMeta(vehicle.vehicleId).dimension}
</p>
                          </div>
                        ) : (
                    <p className="flex gap-6 text-sm text-gray-500">
  <span>
    W: {getVehicleMeta(vehicle.vehicleId).weight}
  </span>

  <span>
    D: {getVehicleMeta(vehicle.vehicleId).dimension}
  </span>
</p>
                        )}
                      </div>
                    </div>

                    <h3 className="self-start text-[18px] font-bold text-gray-900 sm:self-center sm:text-[20px]">
                      ₹{vehicle.price}
                    </h3>
                  </div>

                  {activeVehicle === vehicle.name && (
                    <div className="border-t border-orange-300 bg-white px-4 py-3 text-sm text-gray-500">
                      {vehicle.best}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default VehicleFareCard;